import request from '@/utils/request'
import { noticessoUrl} from '@/config/net.config.js'
import qs from 'qs'

/**
 * 查询通知公告(学生)
 * @returns 
 */
 export function queryNotice(data,ydmhtoken) {
    return request({
      url: noticessoUrl+'/api/news/list?'+qs.stringify(data),
      head: 'application/json;charset=UTF-8',
      method: 'get',
      token:ydmhtoken
    })
  }
  /**
 * 查询通知公告(老师)
 * @returns 
 */
 export function queryNoticeMoreUrl(data,ydmhtoken) {
  return request({
    url: noticessoUrl+'/api/base/portal/wgsUserInfo/queryNoticeMoreUrl?'+qs.stringify(data),
    head: 'application/json;charset=UTF-8',
    method: 'get',
    token:ydmhtoken
  })
}
  /**
   * 查询通知详情
   * @param {} id 
   * @returns 
   */
  export function queryNoticeInfo(id) {
    return request({
      url: '/api/news/getNewsDetail?id='+id,
      head: 'application/json;charset=UTF-8',
      method: 'get',
    })
  }